module.exports = __webpack_public_path__ + "img/scotland.db814740.svg";